const PHONE_MASK_LONG = '(99) 9 9999-9999';
const PHONE_MASK_SHORT = '(99) 9999-99999';
const PHONE_MASK_SWITCH_LENGTH = 14;

export function getPhoneMask(maskedValue: string | undefined): string {
  return (maskedValue?.length ?? 0) > PHONE_MASK_SWITCH_LENGTH ? PHONE_MASK_LONG : PHONE_MASK_SHORT;
}

export const BRAZILIAN_PHONE_MIN_DIGITS = 10;
export const BRAZILIAN_PHONE_MAX_DIGITS = 11;

const COUNTRY_CODE = '55';

export function normalizePhoneDigits(value: string | undefined): string {
  const digits = (value ?? '').replace(/\D/g, '').replace(/^0+/, '');

  if (digits.length > BRAZILIAN_PHONE_MAX_DIGITS && digits.startsWith(COUNTRY_CODE)) {
    return digits.slice(COUNTRY_CODE.length);
  }

  return digits;
}

export function isBrazilianPhone(value: string | undefined): boolean {
  const { length } = normalizePhoneDigits(value);

  return length >= BRAZILIAN_PHONE_MIN_DIGITS && length <= BRAZILIAN_PHONE_MAX_DIGITS;
}

const BRAZILIAN_MOBILE_PHONE = /^[1-9]\d9\d{8}$/;

export function isBrazilianMobilePhone(value: string | undefined): boolean {
  return BRAZILIAN_MOBILE_PHONE.test((value ?? '').replace(/\D/g, ''));
}

export const maskPhone = (value: string) => {
  if (!value) {
    return '';
  }

  let maskedValue = value.replace(/\D/g, '');
  maskedValue = maskedValue.replace(/^(\d{2})(\d)/g, '($1) $2');
  maskedValue = maskedValue.replace(/(\d)(\d{4})$/, '$1-$2');
  return maskedValue;
};

export function formatPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  } else if (cleaned.length === 10) {
    const match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  }
  return phone;
}

export const generateWhatsAppUrl = (phone: string, message?: string): string => {
  let phoneNumber = phone.replace(/[^\d]/g, '');
  phoneNumber = phoneNumber.startsWith('55') ? phoneNumber : `55${phoneNumber}`;

  return `https://wa.me/${phoneNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
